import * as types from './types';
import { fetchGet, fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';

export function onDoubtTopicResponse(response) {
  return {
    type: types.DOUBT_TOPIC_RESPONSE,
    response,
  };
}
export function onFetchQuestionListResponse(response) {
  return {
    type: types.FETCH_QUESTION_LIST_RESPONSE,
    response,
  };
}
export function onFetchCommentListResponse(response) {
  return {
    type: types.FETCH_COMMENT_LIST_RESPONSE,
    response,
  };
}
export function onInsertQuestionItemResponse(response) {
  return {
    type: types.INSERT_QUESTION_ITEM_RESPONSE,
    response,
  };
}

export function onInsertCommentItemResponse(response) {
  return {
    type: types.INSERT_STUDENT_COMMENT_ITEM_RESPONSE,
    response,
  };
}
export const insertQuestionItem = async (insertQuestion, dispatch) => {
  dispatch(onInsertQuestionItemResponse(insertQuestion));

};
export const insertCommentItem = async (insertComment, dispatch) => {
  dispatch(onInsertCommentItemResponse(insertComment));
};


export const studentDiscussionFetch = async (jwtToken, dispatch) => {
  const url = 'api/FacultyDoubtForumList';
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      // if (!get(data, 'IsLoggedIn', true)) {
      //   dispatch(
      //     openSnackBar({
      //       message: 'Multiple logins detected, please login again to continue',
      //       severity: 'warning',
      //     }),
      //   );
      //   return dispatch(logOut());
      // }
      dispatch(onDoubtTopicResponse(data));
    });
};

export const studentQuestionList = async (forumCode, jwtToken, dispatch) => {
  const url = `api/FacultyDoubtForumQuestion/${forumCode}`;
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      // if (!get(data, 'IsLoggedIn', true)) {
      //   dispatch(
      //     openSnackBar({
      //       message: 'Multiple logins detected, please login again to continue',
      //       severity: 'warning',
      //     }),
      //   );
      //   return dispatch(logOut());
      // }
      dispatch(onFetchQuestionListResponse(data));
    });
};

export const studentDiscussionComments = async (
  questionCode,
  jwtToken,
  dispatch,
) => {
  const url = `api/FacultyDoubtForumQuestionDetail/${questionCode}`;
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      // if (!get(data, 'IsLoggedIn', true)) {
      //   dispatch(
      //     openSnackBar({
      //       message: 'Multiple logins detected, please login again to continue',
      //       severity: 'warning',
      //     }),
      //   );
      //   return dispatch(logOut());
      // }
      dispatch(onFetchCommentListResponse(data));
    });
};

// * Like/Dislike Comments
export const likeDislikeComment = (action, id, jwtToken, dispatch) => {
  let body = {
    Action: action,
    DFQID: id,
  };
  fetchPost('api/studentdlikedislikecomment', body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
    });
};

// Close Question
export const closeQuestion = (id, jwtToken, dispatch) => {
  let body = {
    QuestionCode: id,
  };
  fetchPost('api/facultyCloseQuestion', body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      studentDiscussionComments(id, jwtToken, dispatch);
    });
};
// Hide and Show Questions
export const hideshowQuestion = (type, id, jwtToken, dispatch) => {
  let body = {
    QuestionCode: id,
  };
  let url =
    type === 'show' ? 'api/facultyShowQuestion' : 'api/facultyHideQuestion';
  fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
    });
};
// Hide and Show Comment
export const hideshowComment = (type, id, jwtToken, dispatch) => {
  let body = {
    DFQID: id,
  };
  let url =
    type === 'show' ? 'api/moderatorshowcomment' : 'api/moderatorhidecomment';
  fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
    });
};

//Re-open Question
export const reOpenQuestion = async (forumCode, jwtToken, dispatch) => {
  const body = {
    QuestionCode: forumCode,
  };
  await fetchPost('api/facultyOpenQuestion', body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      studentDiscussionComments(forumCode, jwtToken, dispatch);
    });
};

// Delete Question
export const deleteFacultyPost = (
  questionCode,
  forumCode,
  jwtToken,
  dispatch,
) => {
  let body = {
    QuestionCode: questionCode,
  };
  fetchPost('api/facultyRejectQuestion', body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      studentQuestionList(forumCode, jwtToken, dispatch);
    });
};

export const submitQuestion = async (
  title,
  desc,
  forumCode,
  auth,
  image,
  video,
  dispatch,
) => {
  let QuestionTitle = title.replace(/^\s+|\s+$/gm, '');
  let QDesc = desc.replace(/^\s+|\s+$/gm, '');
  try {
    if (!QuestionTitle || !forumCode || !auth || !(QDesc || image || video)) {
      dispatch(
        openSnackBar({
          message: 'Please enter the required field',
          severity: 'warning',
        }),
      );
      return Promise.reject();
    }

    const url = 'api/facultysubmitquestion';
    let body = {
      ForumCode: forumCode,
      QuestionTitle: QuestionTitle,
      QuestionDetail: QDesc,
    };

    if (image) {
      body.QuestionImage = image;
    }
    if (video) {
      body.VideoURL = video;
    }

    await fetchPost(url, body, auth)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({ message: 'Some error occurred', severity: 'error' }),
          );
        }
        // if (!get(data, 'IsLoggedIn', true)) {
        //   dispatch(
        //     openSnackBar({
        //       message:
        //         'Multiple logins detected, please login again to continue',
        //       severity: 'warning',
        //     }),
        //   );
        //   return dispatch(logOut());
        // }
        return dispatch(
          openSnackBar({
            message: 'Question submitted successfully ',
            severity: 'success',
          }),
        );
      });
  } catch (err) {
    console.log('Error - ', err);
  }
};

export const submitComment = async (
  desc,
  questionCode,
  image,
  video,
  auth,
  dispatch,
) => {
  let commentDesc = desc.replace(/^\s+|\s+$/gm, '');
  try {
    if (!(questionCode && auth && (commentDesc || image || video))) {
      dispatch(
        openSnackBar({
          message: 'Please enter the required field',
          severity: 'warning',
        }),
      );
      return Promise.reject();
    }

    const url = 'api/facultysubmitComment';
    let body = {
      QuestionCode: questionCode,
    };
    if (desc) {
      body.DiscussionDetail = commentDesc;
    }
    if (image) {
      body.DiscussionImage = image;
    }
    if (video) {
      body.VideoURL = video;
    }

    await fetchPost(url, body, auth)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({ message: 'Some error occurred', severity: 'error' }),
          );
        }
        // if (!get(data, 'IsLoggedIn', true)) {
        //   dispatch(
        //     openSnackBar({
        //       message:
        //         'Multiple logins detected, please login again to continue',
        //       severity: 'warning',
        //     }),
        //   );
        //   return dispatch(logOut());
        // }
        return dispatch(
          openSnackBar({
            message: 'Comment submitted successfully',
            severity: 'success',
          }),
        );
      });
  } catch (err) {
    dispatch(
      openSnackBar({
        message: 'Please enter the required field',
        severity: 'warning',
      }),
    );
  }
};
